import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Image from "next/image";
import { colors } from "@/utils/const";

export function OfferStep({
  stepNumber,
  content,
  img,
  alt,
  isArabic = false,
  cardColor = colors.orange,
}) {
  const imageOnRight = isArabic;
  return (
    <Box
      sx={{
        position: "relative",
        width: { xs: "95%", sm: "100%", md: 520 },
        minHeight: { xs: 160, md: 220 },
        borderRadius: 3,
        bgcolor: cardColor,
        overflow: "visible",
        px: { xs: 3, md: 5 },
        py: { xs: 3, md: 4 },
        display: "flex",
        alignItems: "center",
        mx: { xs: "auto", sm: 0 },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 16,
          ...(imageOnRight ? { left: 16 } : { right: 16 }),
          fontSize: { xs: 34, md: 44 },
          fontWeight: 800,
          color: colors.navy,
          lineHeight: 1,
          userSelect: "none",
        }}
      >
        {stepNumber}
      </Box>

      <Typography
        sx={{
          color: "#fff",
          fontSize: { xs: 18, md: 24 },
          fontWeight: 400,
          maxWidth: { xs: "100%", sm: "95%", md: 400 },
          ...(imageOnRight
            ? { pr: { xs: 14, md: 20, lg: 20 } }
            : { pl: { xs: 14, md: 20, lg: 20 } }),

          direction: isArabic ? "rtl" : "ltr",
        }}
      >
        {content}
      </Typography>

      <Box
        sx={{
          position: "absolute",
          zIndex: 10,
          top: { xs: 0, md: -30 },
          transform: "translateY(-35%)",
          ...(imageOnRight
            ? { right: { xs: 0, md: 20 } }
            : { left: { xs: 0, md: 20 } }),
          width: { xs: 130, md: 170 },
          height: { xs: 220, md: 350 },
          overflow: "visible",
          pointerEvents: "none",
        }}
      >
        <Image
          src={img}
          alt={alt}
          fill
          style={{ objectFit: "contain" }}
        />
      </Box>
    </Box>
  );
}
